import { type ReactNode } from 'react'
import type { ComponentPropsWithoutRef, ElementType } from 'react'
import { twMerge } from 'tailwind-merge'

export type TColProps<T extends ElementType = 'div'> = {
  children: ReactNode
  className?: string
  buttonClassName?: string
  onClick?: () => void
  as?: T
} & Omit<
  ComponentPropsWithoutRef<T>,
  'as' | 'children' | 'className' | 'onClick'
>

export const Col = <T extends ElementType = 'div'>(props: TColProps<T>) => {
  const {
    children,
    className,
    onClick,
    as: Component = 'div',
    buttonClassName,
    ...rest
  } = props
  return (
    <Component className={twMerge('flex flex-col w-full', className)} {...rest}>
      {onClick ? (
        <button
          onClick={onClick}
          className={twMerge(
            'w-full h-full flex flex-col items-center',
            buttonClassName,
          )}
        >
          {children}
        </button>
      ) : (
        children
      )}
    </Component>
  )
}
